import { useTranslation } from 'react-i18next';
import { DataTable } from '@ui-kit';
import type { DataTableColumn } from '@ui-kit';
import type { LintViolation } from '../types/terminology';

export interface LintResultTableProps {
  violations: LintViolation[];
}

/** 검사 위반 목록 — line/column/matched/suggestion/reason/source */
export function LintResultTable({ violations }: LintResultTableProps) {
  const { t } = useTranslation();

  const columns: DataTableColumn<LintViolation>[] = [
    {
      key: 'line',
      header: t('terminologyManagement.checker.col.line'),
      width: '8%',
      render: (row) => <span>{row.line}</span>,
    },
    {
      key: 'column',
      header: t('terminologyManagement.checker.col.column'),
      width: '8%',
      render: (row) => <span>{row.column}</span>,
    },
    {
      key: 'matched',
      header: t('terminologyManagement.checker.col.matched'),
      width: '18%',
      render: (row) => (
        <span style={{ fontFamily: 'var(--font-family-mono)', fontWeight: 600, color: 'var(--color-danger)' }}>
          {row.matched}
        </span>
      ),
    },
    {
      key: 'suggestion',
      header: t('terminologyManagement.checker.col.suggestion'),
      width: '18%',
      render: (row) => (
        <span style={{ fontWeight: 600, color: 'var(--color-success)' }}>{row.suggestion}</span>
      ),
    },
    {
      key: 'reason',
      header: t('terminologyManagement.checker.col.reason'),
      width: '28%',
      render: (row) => (
        <span style={{ color: 'var(--color-text-secondary)' }}>{row.reason ?? '-'}</span>
      ),
    },
    {
      key: 'source',
      header: t('terminologyManagement.checker.col.source'),
      width: '20%',
      render: (row) => (
        <span style={{ fontFamily: 'var(--font-family-mono)', fontSize: 'var(--font-size-xs)' }}>
          {row.source}
        </span>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={violations}
      rowKey={(row) => `${row.line}-${row.column}-${row.matched}`}
    />
  );
}
